'use client'

import { RootArgs, RootNode } from 'generated/hypertune'
import { useHypertuneSource } from 'generated/hypertune.react'

let hypertuneRootSingleton: RootNode = new RootNode({
  logger: null,
  context: null,
  parent: null,
  step: null,
  initDataHash: null,
  expression: null
})

export function getHypertune() {
  return hypertuneRootSingleton
}

export default function HypertuneSingletonCreator({ rootArgs, children }: { rootArgs: RootArgs; children: React.ReactNode }) {
  const hypertuneSource = useHypertuneSource()

  const hypertuneRoot = hypertuneSource.root({ args: rootArgs })

  hypertuneRootSingleton = hypertuneRoot

  return children
}
